"use strict";

import {
  accountConstants,
  accountTypesConstants,
  responseCodes,
} from "../_constants";

const INITIAL_ACCOUNT_DATA_STATE = {
  isAccountListLoading: false,
  accountList: {
    list: [],
  },
  accountListFail: false,
  accountDetails: null,
  isEPassbookListLoading: false,
  ePassbookList: {
    list: [],
  },
  isAccountHistoryListLoading: false,
  accountHistoryList: [],
  transactionCurrencyCode: "",
  productList: [],
  eligibleDebitAccountList: [],
  minimumDepositLimit: "",
  maximumDepositLimit: "",
  initiateData: null,
  otpConfirmationData: {},
  otpConfirmResponseCode: "",
  otpConfirmResponseMessage: "",
  savingReceiptDetails: {},
  selectedDebitAccount: {},
  depositAmount: "",
  savingAccountProductType: "",
  savingAccountProductCode: "",
  selectedSavingsDebitAccount: "",
  isSavingAccountFormChanged: false,
  activeAccountTab: accountTypesConstants.ALL_ACCOUNT_TYPE,
};

export function account(state = INITIAL_ACCOUNT_DATA_STATE, action) {
  switch (action.type) {
    case accountConstants.ACCOUNT_LIST_REQUEST:
      return {
        ...state,
        isAccountListLoading: true,
        accountList: {
          ...state.accountList,
          list: [],
        },
        accountListFail: false,
      };
    case accountConstants.ACCOUNT_LIST_COMPLETE:
      return {
        ...state,
        accountList: {
          ...state.accountList,
          list: action.payload?.data?.accountDetails,
        },
        isAccountListLoading: false,
        customerName: action.payload?.data?.customerName,
        accountListFail: false,
      };

    case accountConstants.ACCOUNT_LIST_ERROR:
      return {
        ...state,
        isAccountListLoading: false,
        accountList: {
          ...state.accountList,
          list: [],
        },
        accountListFail: true,
      };
    case accountConstants.EPASSBOOK_LIST_REQUEST:
      return {
        ...state,
        isEPassbookListLoading: true,
        ePassbookList: {
          ...state.ePassbookList,
          list: [],
        },
      };

    case accountConstants.EPASSBOOK_LIST_COMPLETE:
      return {
        ...state,
        isEPassbookListLoading: false,
        ePassbookList: {
          ...state.ePassbookList,
          list: action.payload.data.transactionList,
        },
      };

    case accountConstants.DASHBOARD_BANNER_LIST_ERROR:
      return {
        ...state,
        isEPassbookListLoading: false,
        ePassbookList: {
          ...state.ePassbookList,
          list: [],
        },
      };

    case accountConstants.ACCOUNT_HISTORY_LIST_REQUEST:
      return {
        ...state,
        isAccountHistoryListLoading: true,
        accountHistoryList: [],
        transactionCurrencyCode: "",
      };
    case accountConstants.ACCOUNT_HISTORY_LIST_COMPLETE:
      return {
        ...state,
        isAccountHistoryListLoading: false,
        transactionCurrencyCode: action?.payload?.data?.transactionCurrencyCode,
        accountHistoryList: action?.payload?.data?.transactions,
      };

    case accountConstants.ACCOUNT_HISTORY_LIST_ERROR:
      return {
        ...state,
        isAccountHistoryListLoading: false,
        accountHistoryList: [],
        transactionCurrencyCode: "",
      };

    case accountConstants.ACCOUNT_DETAILS_REQUEST:
      return {
        ...state,
        accountDetails: null,
      };
    case accountConstants.ACCOUNT_DETAILS_COMPLETE:
      return {
        ...state,
        accountDetails: action.payload?.data?.accountDetail,
      };
    case accountConstants.ACCOUNT_DETAILS_ERROR:
      return {
        ...state,
        accountDetails: null,
      };

    case accountConstants.GET_ELIGIBLE_CASA_LIST_REQUEST:
      return {
        ...state,
        isEligibleCasaListLoading: true,
        productList: [],
        eligibleDebitAccountList: [],
        minimumDepositLimit: "",
        maximumDepositLimit: "",
      };

    case accountConstants.GET_ELIGIBLE_CASA_LIST_COMPLETE:
      return {
        ...state,
        productList: action.payload?.data?.productList,
        eligibleDebitAccountList:
          action.payload?.data?.eligibleDebitAccountList,
        minimumDepositLimit:
          action.payload?.data?.configuration?.minimumDepositLimit,
        maximumDepositLimit:
          action.payload?.data?.configuration?.maximumDepositLimit,
        isEligibleCasaListLoading: false,
      };

    case accountConstants.GET_ELIGIBLE_CASA_LIST_ERROR:
      return {
        ...state,
        isEligibleCasaListLoading: false,
        productList: [],
        eligibleDebitAccountList: [],
        minimumDepositLimit: "",
        maximumDepositLimit: "",
      };

    case accountConstants.SAVING_ACCOUNTS_OPEN_INITIATE_REQUEST:
      return {
        ...state,
        initiateData: {},
      };
    case accountConstants.SAVING_ACCOUNTS_OPEN_INITIATE_COMPLETE:
      return {
        ...state,
        initiateData: action?.payload?.data,
      };

    case accountConstants.SAVING_ACCOUNTS_OPEN_INITIATE_ERROR:
      return {
        ...state,
        initiateData: null,
      };
    case accountConstants.SAVING_ACCOUNTS_OTP_RESEND_REQUEST:
      return {
        ...state,
        otpConfirmationData: {},
      };

    case accountConstants.SAVING_ACCOUNTS_OTP_RESEND_COMPLETE:
      return {
        ...state,
        otpConfirmationData: action?.payload?.data,
      };

    case accountConstants.SAVING_ACCOUNTS_OTP_RESEND_ERROR:
      return {
        ...state,
        otpConfirmationData: {},
      };

    case accountConstants.SAVING_ACCOUNTS_OTP_CONFIRMATION_REQUEST:
      return {
        ...state,
        otpConfirmResponseCode: "",
        otpConfirmResponseMessage: "",
      };

    case accountConstants.SAVING_ACCOUNTS_OTP_CONFIRMATION_COMPLETE:
      return {
        ...state,
        otpConfirmationData: action?.payload?.data,
        otpConfirmResponseCode: action?.payload?.data?.responseCode,
        otpConfirmResponseMessage: action?.payload?.data?.message,

        initiateData: {},
      };

    case accountConstants.SAVING_ACCOUNTS_OTP_CONFIRMATION_ERROR:
      return {
        ...state,
        otpConfirmResponseCode: action?.payload?.responseCode,
        otpConfirmResponseMessage: action?.payload?.message,
        initiateData: {},
      };

    case accountConstants.SAVING_ACCOUNTS_RECEIPT_REQUEST:
      return {
        ...state,
        savingReceiptDetails: {},
      };

    case accountConstants.SAVING_ACCOUNTS_RECEIPT_COMPLETE:
      return {
        ...state,
        savingReceiptDetails: action?.payload?.data,
      };

    case accountConstants.SAVING_ACCOUNTS_RECEIPT_ERROR:
      return {
        ...state,
        savingReceiptDetails: {},
      };

    case accountConstants.SET_SELECTED_SAVINGS_DEBIT_ACCOUNT:
      return {
        ...state,
        selectedDebitAccount: action?.payload,
      };

    case accountConstants.SET_SAVING_ACCOUNT_PRODUCT_TYPE:
      return {
        ...state,
        savingAccountProductType: action?.payload,
      };

    case accountConstants.SET_SAVING_ACCOUNT_PRODUCT_CODE:
      return {
        ...state,
        savingAccountProductCode: action?.payload,
      };

    case accountConstants.SET_SAVING_ACCOUNT_AMOUNT:
      return {
        ...state,
        depositAmount: action?.payload,
      };

    case accountConstants.CLEAR_SAVING_ACCOUNTS:
      return {
        ...state,
        savingAccountProductCode: "",
        savingAccountProductType: "",
        depositAmount: "",
        initiateData: null,
        otpConfirmationData: null,
        isSavingAccountFormChanged: false,
        selectedDebitAccount: null,
        otpConfirmResponseCode: null,
        savingReceiptDetails: null,
      };

    case accountConstants.SET_SAVING_ACCOUNT_FORM_CHANGED:
      return {
        ...state,
        isSavingAccountFormChanged: action?.payload,
      };

    case accountConstants.SET_ACTIVE_TAB:
      return {
        ...state,
        activeAccountTab: action.payload,
      };

    case accountConstants.CLEAR_ACCOUNT_DETAILS:
      return {
        ...state,
        accountDetails: null,
      };
  }

  return state;
}
